export default __webpack_public_path__ + "static/media/edit_icon_disabled.1e1be13c.svg";